// Dünne Wrapper um die BESTEHENDEN sicheren Merchant-RPCs. Keine
// Business-Logik, keine clientseitige Statusmaschine. Rückgabe { ok, code }.
import { getSupabase } from "./supabase";
import { extractErrorCode } from "./errors";

export interface ActionResult {
  ok: boolean;
  code?: string;
}

async function callRpc(fn: string, params: Record<string, unknown>): Promise<ActionResult> {
  try {
    const { error } = await getSupabase().rpc(fn, params);
    if (error) return { ok: false, code: extractErrorCode(error) };
    return { ok: true };
  } catch (e) {
    return { ok: false, code: extractErrorCode(e) };
  }
}

export function acceptOrder(orderId: string, prepMinutes: number): Promise<ActionResult> {
  return callRpc("merchant_accept_order", { p_order_id: orderId, p_prep_minutes: prepMinutes });
}

export function rejectOrder(orderId: string, reasonCode: string, comment?: string): Promise<ActionResult> {
  return callRpc("merchant_reject_order", { p_order_id: orderId, p_reason_code: reasonCode, p_comment: comment ?? null });
}

export function markPreparing(orderId: string): Promise<ActionResult> {
  return callRpc("merchant_mark_preparing", { p_order_id: orderId });
}

export function markReady(orderId: string): Promise<ActionResult> {
  return callRpc("merchant_mark_ready", { p_order_id: orderId });
}
